import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PremiumSportsEntertainment from "./sections/PremiumSportsEntertainment";
import SkillBuildingLaboratories from "./sections/SkillBuildingLaboratories";
import IndustryIntelligence from "./sections/IndustryIntelligence";
import BeginYourFreeTrial from "./sections/BeginYourFreeTrial";
import YeFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PremiumSportsEntertainment />
      <SkillBuildingLaboratories />
      <IndustryIntelligence />
      <BeginYourFreeTrial />
      <YeFooter />
    </div>;
}